<template>
  <div
    id="outer"
    ref="outer"
    :class="{'fixed': stuck, 'show-mobile-menu': showMobileMenu, 'pad-banner': padForBanner}"
  >
    <div id="inner">
      <div
        id="left"
        class="flex-vertical"
      >
        <p>BIAS MINI</p>
        <div class="vl" />
        <a>GUITAR</a>
        <div class="mobile-menu">
          <span
            v-if="!showMobileMenu"
            class="menu menu-open"
            @click="showMobileMenu = true"
          />
          <span
            v-else
            class="menu menu-close"
            @click="showMobileMenu = false"
          />
        </div>
      </div>
      <div class="right right-mobile flex-vertical">
        <a href="https://item.taobao.com/item.htm?id=600745577094&qq-pf-to=pcqq.c2c"><button class="mobile">购买</button></a>
      </div>
      <div class="right flex-vertical">
        <router-link to="/bias-mini-guitar">
          概述
        </router-link>
        <router-link to="/bias-mini-guitar/sound">
          音色
        </router-link>
        <router-link to="/bias-mini-guitar/spec">
          规格
        </router-link>
        <a href="https://help.positivegrid.com/hc/en-us/categories/360002059132-BIAS-MINI-%E6%94%AF%E6%8C%81%E9%A1%B5%E9%9D%A2">帮助中心</a>
        <a href="https://item.taobao.com/item.htm?id=600745577094&qq-pf-to=pcqq.c2c"><button>购买</button></a>
      </div>
    </div>
    <div
      v-if="showMobileMenu"
      class="mobile-menu-extend"
    >
      <hr>
      <span @click="showMobileMenu = false">
        <router-link to="/bias-mini-guitar">概述</router-link>
        <router-link to="/bias-mini-guitar/sound">音色</router-link>
        <router-link to="/bias-mini-guitar/spec">规格</router-link>
        <a href="https://help.positivegrid.com/hc/en-us/categories/360002059132-BIAS-MINI-%E6%94%AF%E6%8C%81%E9%A1%B5%E9%9D%A2">帮助中心</a>
      </span>
    </div>
    <hr v-if="!stuck">
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      stuck: false,
      showMobileMenu: false,
      padForBanner: true,
      prevScroll: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    goToBuyNow () {
      window.document.querySelector('#software-title').scrollIntoView()
    },
    handleScroll () {
      if (!this.$refs.outer) {
        return
      }
      let boundingRect = this.$refs.outer.getBoundingClientRect()
      let topPosition = boundingRect.top
      if (!this.stuck && topPosition < 0) {
        this.stuck = true
      } else if (window.pageYOffset < 54) {
        this.stuck = false
      }
      if (this.prevScroll > window.pageYOffset) {
        this.padForBanner = true
      } else {
        this.padForBanner = false
      }
      this.prevScroll = window.pageYOffset
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/base/breakpoint.scss";
div#outer {
  position: absolute;
  top: 42px;
  padding: 0 54px;
  width: 100%;
  box-sizing: border-box;
  z-index: 0;
  @include breakpoint("medium") {
    z-index: 1;
  }
}

div#inner {
  height: 59px;
  /* line-height: 59px; */
}

p, a {
  /* line-height: 59px; */
}

hr {
  margin: 0;
  opacity: 0.3;
}

#inner {
  opacity: initial;
}

p {
  margin: 0;
  display: inline-block;
  font-family: Roboto;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
}

a {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: #d7d7d7;
}

.vl {
  border-left: 1px solid #afafaf;
  height: 20px;
  margin: 0 20px;
  width: 1px;
  display: inline-block;
}

.right {
  float: right;
}

.right > * {
  margin-left: 30px;
}

a {
  text-decoration: none;
}

#left {
  float: left;
  height: 100%;
}

.right {
  float: right;
  height: 100%;
}

.fixed {
  position: fixed !important;
  z-index: 1 !important;
  opacity: 0.9;
  background-color: black;
  top: 0px;
  width: 100%;
  transition: top .5s;
}

div#outer.pad-banner {
  top: 14px;
  transition: top .5s;
  z-index: 1 !important;
}

@media screen and (max-width: 768px) {
  .right {
    display: none;
  }
  .right-mobile {
    display: flex;
  }
  div#outer {
    padding: 0 10px;
    width: calc(100%);
  }
  div#inner {
    height: 49px;
  }
  div#outer.pad-banner {
    top: 0px;
  }
}
.app-store {
  background-image: url(../assets/app-store.svg);
  width: 110px;
  height: 40px;
  background-size: cover;
}

span.menu {
  float: right;
  width: 12px;
  height: 9px;
  margin-top: 3px;
  vertical-align: middle;
  display: inline-block;
  background-size: cover;
  margin-left: 0.5rem;
}

span.menu-open {
  background-image: url(../assets/ic-keyboard-arrow-up-24-px@2x.png);
}
span.menu-close {
  background-image: url(../assets/ic-keyboard-arrow-down-24-px@2x.png);
}
.mobile-menu-extend {
  opacity: 0.9;
  height: 300px;
}
.show-mobile-menu {
  background-color: #0f0f0f;
}
.mobile-menu-extend hr {
  margin-bottom: 10px;
}
.mobile-menu-extend a {
  display: block;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: white;
  text-decoration: none;
  margin-top: 20px;
}

.invert {
  background-color: unset;
  border: 1px solid #bf000a;
  padding:  0 10px;
}

.show-mobile-menu {
  z-index: 1;
}

button {
  width: 120px;
}
button.mobile {
  width: 60px;
}
.right-mobile > button:nth-of-type(2) {
  margin-left: 0.5rem;
}
.mobile-menu {
  display: none;
}
.right-mobile {
  display: none;
}
@media screen and (max-width: 768px) {
  .right-mobile {
    display: flex;
  }
  .right-mobile > button:nth-of-type(1) {
    margin-left: 0;
  }
  .mobile-menu {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bias-mini-guitar-banner.vue